export default function reducerSubscriptions(state = {}, action) {
  switch (action.type) {
    case 'GET_SUBSCRIPTIONS':
      return {
        ...state,
        subscriptions: action.payload.data,
      }
    default:
      return state
  }
}
